import type {
  DealerOptionDto,
  FactoryOptionDto,
  MachineAttachmentDto
} from '@api/machines'
import {
  type ColumnCellTemplateData,
  MolsonBox,
  MolsonIcon,
  MolsonTypography
} from '@components/reusable'
import { type molsonTheme } from '@theme'
import type { TFunction } from 'i18next'
import { CustomChip } from '../custom-chip/CustomChip'

export const masterDetailCustomHeader = (
  params: ColumnCellTemplateData,
  theme: typeof molsonTheme,
  keyPrefix: string,
  t: TFunction
) => {
  const isTopLevelEqArchived = params.data.isArchived

  const tableItem = params.data

  const hasArchivedOptions = () => {
    const listToCheck:
      | DealerOptionDto[]
      | FactoryOptionDto[]
      | MachineAttachmentDto[] = [
      ...tableItem.addedDealerOptions,
      ...tableItem.addedFactoryFit,
      ...tableItem.machineAttachments
    ]

    return listToCheck.some(element => element.isArchived)
  }

  const hasArchivedServices = () => {
    const archivedWarranty = tableItem?.addedWarranty?.isArchived
    const archivedServiceContract = tableItem?.addedServiceContract?.isArchived
    const archivedTransport = tableItem?.addedTransportOption?.isArchived

    return archivedWarranty || archivedServiceContract || archivedTransport
  }

  const showErrorIcon =
    (hasArchivedOptions() || hasArchivedServices()) && !isTopLevelEqArchived

  return (
    <MolsonBox display="flex" alignItems="center" gap={2}>
      <MolsonTypography
        fontWeight={700}
        color={
          isTopLevelEqArchived
            ? theme.palette.secondary.darkOpaque
            : theme.palette.secondary[900]
        }
      >
        {params.data.itemName}
      </MolsonTypography>

      {showErrorIcon && (
        <MolsonIcon variant="ERROR_OUTLINE" iconColor="error" />
      )}

      {isTopLevelEqArchived && (
        <CustomChip
          text={t(`${keyPrefix}.archived`)}
          customSx={{
            fontWeight: 700,
            color: theme.palette.secondary[900],
            border: `1px solid ${theme.palette.secondary[300]}`,
            backgroundColor: theme.palette.secondary[200],
            padding: '6px 12px'
          }}
        />
      )}
    </MolsonBox>
  )
}
